// extracted by mini-css-extract-plugin
export default {"bodyCard":"Card_bodyCard__wpp3Z"};